module.exports = __webpack_public_path__ + "img/wildlife-fish-logo.6380953f.jpg";